import { render, staticRenderFns } from "./cutoff-settings.vue?vue&type=template&id=217a1b08&scoped=true&"
import script from "./cutoff-settings.vue?vue&type=script&lang=js&"
export * from "./cutoff-settings.vue?vue&type=script&lang=js&"
import style0 from "./cutoff-settings.vue?vue&type=style&index=0&id=217a1b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a1b08",
  null
  
)

component.options.__file = "cutoff-settings.vue"
export default component.exports